// extracted by mini-css-extract-plugin
module.exports = {"checkLabel":"RadioLabel_checkLabel__3vH2-","borderTop":"RadioLabel_borderTop__rPFkG","borderBottom":"RadioLabel_borderBottom__1CANu"};